// Brand logos for Mobile Money providers (Swift Link)
// Pure SVG, no external dependencies.

export function MoovMoneyLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0"
      style={{ width: size, height: size, background: "#FFCC00" }}
      aria-label="Moov Money"
    >
      <svg viewBox="0 0 32 32" width={size * 0.6} height={size * 0.6} fill="none">
        <path d="M4 22V10l6 8 6-8v12" stroke="#003D6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="24" cy="16" r="5" stroke="#003D6E" strokeWidth="3" />
      </svg>
    </span>
  );
}

export function TMoneyLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0"
      style={{ width: size, height: size, background: "#E30613" }}
      aria-label="T-Money / Mixx by Yas"
    >
      <span className="text-white font-bold" style={{ fontSize: size * 0.45, lineHeight: 1, letterSpacing: "-0.05em" }}>
        T<span style={{ color: "#FFD700" }}>$</span>
      </span>
    </span>
  );
}

export function AirtelMoneyLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0"
      style={{ width: size, height: size, background: "#E40514" }}
      aria-label="Airtel Money"
    >
      <svg viewBox="0 0 32 32" width={size * 0.6} height={size * 0.6} fill="none">
        <path
          d="M16 5 C 9 5 5 11 5 16 c 0 5 4 11 11 11 c 7 0 11-6 11-11 c 0-5-4-11-11-11 z M16 11 c 3 0 5 2 5 5 c 0 3-2 5-5 5 c-3 0-5-2-5-5 c 0-3 2-5 5-5 z"
          fill="#FFFFFF"
        />
      </svg>
    </span>
  );
}

const PAYPAL_BLUE = "#003087";
const PAYPAL_LIGHT = "#009CDE";

export function PaypalLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0 bg-white border border-gray-200"
      style={{ width: size, height: size }}
      aria-label="PayPal"
    >
      <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62}>
        <path fill={PAYPAL_BLUE} d="M7.3 22 5.7 12.5h2.7l1.6 9.5H7.3z" />
        <path fill={PAYPAL_BLUE} d="M11.7 2h5.6c3.3 0 5 1.7 4.4 4.8-.6 3.5-3 5.2-6.4 5.2h-2.1l-.9 5.5h-3l2.4-15.5z" />
        <path fill={PAYPAL_LIGHT} d="M9.7 4h5.6c3.3 0 5 1.7 4.4 4.8-.6 3.5-3 5.2-6.4 5.2h-2.1l-.9 5.5h-3L9.7 4z" />
      </svg>
    </span>
  );
}

export function WeroLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0"
      style={{ width: size, height: size, background: "#1A1A2E" }}
      aria-label="Wero"
    >
      <span className="font-bold text-white" style={{ fontSize: size * 0.36, letterSpacing: "-0.05em" }}>
        wero
      </span>
    </span>
  );
}

export function SepaLogo({ size = 36 }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg shadow-sm shrink-0"
      style={{ width: size, height: size, background: "#003399" }}
      aria-label="Virement SEPA"
    >
      <span className="font-bold text-white" style={{ fontSize: size * 0.3, letterSpacing: "0.02em" }}>
        SEPA
      </span>
    </span>
  );
}

const LOGOS = {
  moov_togo: MoovMoneyLogo,
  tmoney_togo: TMoneyLogo,
  airtel_gabon_gafr: AirtelMoneyLogo,
  airtel_gabon: AirtelMoneyLogo,
  airtel_gabon_frga: AirtelMoneyLogo,
  moov_gabon: MoovMoneyLogo,
  moov_gabon_frga: MoovMoneyLogo,
  paypal: PaypalLogo,
  paypal_send: PaypalLogo,
  wero: WeroLogo,
  wero_send: WeroLogo,
  virement_instantane: SepaLogo,
};

export default function BrandLogo({ method, size = 36 }) {
  const Logo = LOGOS[method];
  if (!Logo) return null;
  return <Logo size={size} />;
}
